// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.input-fieldtranslate {
  padding: 10px 70px 10px 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
}

.clear-icon {
  right: 10px;
  /* Adjust based on size of icons */
}

.save-icon {
  width: 23px;
  height: 23px;
}

.actionTable {
  top: 18px;
  right: 15px;
}

.arrowButton,
.mapButton {
  cursor: pointer;
  width: 45px;
  height: 35px;
  background-color: transparent;
}

.arrowButton:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.arrowButton:first-child {
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
}

.arrowButton:last-child {
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}

.customPaginationBorder {
  border-style: solid;
  border-width: 1px;
}

.languageTable table {
  border-collapse: collapse;
  border-width: 2px;
  border-style: solid;
}

/* .languageTable {
  width: 1000px;
  overflow: hidden;
}

.languageTable>table {
  width: 1000px;
  overflow: scroll;
}

.languageTable thead>tr>th:nth-child(1) {
  width: 20%;
}

.languageTable thead>tr>th {
  width: 200px;
}

.languageTable tbody>tr>td {
  width: 200px;
} */

.language-table{
  text-wrap: nowrap;
  border: none;
  font-family: Poppins !important;
  font-size: 16px;
  font-weight: 500;
  padding: 5px;
  position: relative;
  width: 130px;
}
.paginationCustomContainer {
  gap: 6px;
  flex-wrap: wrap;
}

.paginationCustomContainer button {
  background-color: #ffffff;
  color: #333;
  border: 1px solid #027af1;
  margin: 0 4px;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.paginationCustomContainer button.active,
.paginationCustomContainer .mapButton.active,
.paginationCustomContainer .theme-bg-color-secondary.active {
  background-color: #027af1 !important;
  color: #ffffff !important;
  border-color: #027af1 !important;
  box-shadow: 0 2px 6px rgba(2, 122, 241, 0.4);
}
.paginationCustomContainer button:hover:not(:disabled) {
  background-color: #005fcc;
  color: #ffffff;
  border-color: #005fcc;
}

.paginationCustomContainer button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #f1f1f1;
  color: #aaa;
  border-color: #ccc;
}

.arrowButton svg {
  vertical-align: middle;
  font-size: 16px;
}
.rotate-load {
  animation: rotate 2s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Language/Manage_Language/Translation.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;EACE,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;;;EAGE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-fieldtranslate {\n  padding: 10px 70px 10px 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.icon {\n  position: absolute;\n  right: 10px;\n  cursor: pointer;\n}\n\n.clear-icon {\n  right: 10px;\n  /* Adjust based on size of icons */\n}\n\n.save-icon {\n  width: 23px;\n  height: 23px;\n}\n\n.actionTable {\n  top: 18px;\n  right: 15px;\n}\n\n.arrowButton,\n.mapButton {\n  cursor: pointer;\n  width: 45px;\n  height: 35px;\n  background-color: transparent;\n}\n\n.arrowButton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.arrowButton:first-child {\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n}\n\n.arrowButton:last-child {\n  border-top-right-radius: 7px;\n  border-bottom-right-radius: 7px;\n}\n\n.customPaginationBorder {\n  border-style: solid;\n  border-width: 1px;\n}\n\n.languageTable table {\n  border-collapse: collapse;\n  border-width: 2px;\n  border-style: solid;\n}\n\n/* .languageTable {\n  width: 1000px;\n  overflow: hidden;\n}\n\n.languageTable>table {\n  width: 1000px;\n  overflow: scroll;\n}\n\n.languageTable thead>tr>th:nth-child(1) {\n  width: 20%;\n}\n\n.languageTable thead>tr>th {\n  width: 200px;\n}\n\n.languageTable tbody>tr>td {\n  width: 200px;\n} */\n\n.language-table{\n  text-wrap: nowrap;\n  border: none;\n  font-family: Poppins !important;\n  font-size: 16px;\n  font-weight: 500;\n  padding: 5px;\n  position: relative;\n  width: 130px;\n}\n.paginationCustomContainer {\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.paginationCustomContainer button {\n  background-color: #ffffff;\n  color: #333;\n  border: 1px solid #027af1;\n  margin: 0 4px;\n  padding: 6px 14px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.paginationCustomContainer button.active,\n.paginationCustomContainer .mapButton.active,\n.paginationCustomContainer .theme-bg-color-secondary.active {\n  background-color: #027af1 !important;\n  color: #ffffff !important;\n  border-color: #027af1 !important;\n  box-shadow: 0 2px 6px rgba(2, 122, 241, 0.4);\n}\n.paginationCustomContainer button:hover:not(:disabled) {\n  background-color: #005fcc;\n  color: #ffffff;\n  border-color: #005fcc;\n}\n\n.paginationCustomContainer button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background-color: #f1f1f1;\n  color: #aaa;\n  border-color: #ccc;\n}\n\n.arrowButton svg {\n  vertical-align: middle;\n  font-size: 16px;\n}\n.rotate-load {\n  animation: rotate 2s linear infinite;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
